export default "__VITE_ASSET__CoZcJ8FJ__"